<script>
import {mapState, mapActions} from 'vuex';

export default {
    computed: {
        ...mapState({
            submitted: state => state.admin.createModal.form.submitted,
            accepted: state => state.admin.createModal.form.accepted,
        }),
    },
    methods: {
        ...mapActions({
            acceptCreateUserForm: 'admin/acceptCreateUserForm',
            cancelCreateUserForm: 'admin/cancelCreateUserForm',
        }),
        accept() {
            this.acceptCreateUserForm();
            this.$emit('accept');
        },
        close($event) {
            if ($event.target.id === 'container') {
                this.cancelCreateUserForm();
            }
        }
    }
}
</script>
<template>
    <div class="admin-edit-modal-form-accept">
        <transition name="fade" mode="out-in">
            <div v-if="submitted" id="container" class="admin-edit-modal-form-accept__container" @click="close($event)">
                <div class="admin-edit-modal-form-accept__body">
                    <div class="admin-edit-modal-form-accept__header">
                        {{ $t('admin.create.accept.header') }}
                    </div>
                    <div class="admin-edit-modal-form-accept__content">
                        {{ $t('admin.create.accept.content') }}
                    </div>
                    <div class="admin-edit-modal-form-accept__button-group">
                        <button class="admin-edit-modal-form-accept__submit" @click="accept">
                            {{ $t('admin.create.accept.buttons.accept') }}
                        </button>
                        <button class="admin-edit-modal-form-accept__cancel" @click="cancelCreateUserForm">
                            {{ $t('admin.create.accept.buttons.cancel') }}
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/AdminCreateModalFormAccept/AdminCreateModalFormAccept.vue